export const GET_ALL_MANIFEST_PRODUCTS = 'GET_ALL_MANIFEST_PRODUCTS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const GET_SINGLE_MANIFEST = 'GET_SINGLE_MANIFEST'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
